import appIcon from "../../images/app_icon.jpg"
import "../../styles/PlayerCardItem.css"
import { convertToCommaString } from "../../helpers/Converter";
import { useNavigate } from "react-router-dom";

export const StatementItem = ({ size, data }) => {
    const navigate = useNavigate();
    let mode = "increased";
    const { company, currency, loan, amount, round } = data;
    let specialCard = null;
    if (loan) specialCard = "Loan (Round " + (round + 1) + ")"
    else if (currency) specialCard = "Currency (Round " + (round + 1) + ")"

    let text = "";

    if (company) {
        if (amount < 0) mode = "decreased";
        text = (amount > 0 ? "+" : "-") + "₹" + convertToCommaString(Math.abs(amount))
    } else {
        if (amount < 0) mode = "decreased";
        text = (amount > 0 ? "+" : "-") + "₹" + convertToCommaString(Math.abs(amount))
    }
    return (
        <div style={{ margin: "14px" }} onClick={() => {
            if(company) {
                navigate(`/company/${company}`);
            }
        }}>
            <div className={`player-cards-item-container-${size}`}>
                <img className={`player-cards-item-image-${size}`} src={company ? `${process.env.REACT_APP_SERVER_URL}/image/${company}.png` : appIcon} alt=""></img>
                <div className={`player-cards-item-price-details-mode-${mode}`}>
                    {<p className="player-cards-item-company">{company ? company.toUpperCase() : specialCard}</p>}
                    {<p style={{ marginTop: "-10px" }}>{text}</p>}
                </div>
            </div>
        </div>
    )
}